import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setMessage('');
        setLoading(true);
        try {
            const API_BASE = process.env.REACT_APP_API_URL || '';
            const res = await fetch(`${API_BASE}/api/auth/forgot-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email })
            });
            const data = await res.json();

            if (!res.ok) {
                throw new Error(data.error || 'שגיאה בשליחת הבקשה');
            }

            setMessage(data.message);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4" dir="rtl">
            <div className="max-w-md w-full bg-white rounded-3xl shadow-xl border border-slate-100 p-8">
                <div className="text-center mb-8">
                    <h2 className="text-3xl font-black text-slate-900">איפוס סיסמה</h2>
                    <p className="text-slate-500 mt-2 text-sm">הזן את האימייל שלך לקבלת קישור איפוס</p>
                </div>
                {error && <div className="bg-red-50 text-red-600 p-4 rounded-xl text-sm font-bold mb-6 text-center border border-red-100">{error}</div>}
                {message && <div className="bg-green-50 text-green-700 p-4 rounded-xl text-sm font-bold mb-6 text-center border border-green-200">{message}</div>}
                
                {!message && (
                    <form onSubmit={handleSubmit} className="space-y-5">
                        <div>
                            <label className="block text-slate-700 font-bold mb-2 text-sm">אימייל</label>
                            <input type="email" value={email} onChange={e => setEmail(e.target.value)} required className="w-full p-3 rounded-xl border border-slate-200 bg-slate-50 focus:bg-white focus:ring-2 focus:ring-blue-500 outline-none transition-all text-left" dir="ltr" />
                        </div>
                        <button disabled={loading} className="w-full bg-blue-600 hover:bg-blue-700 text-white font-black py-4 rounded-xl transition-all shadow-md disabled:bg-blue-400">
                            {loading ? 'שולח...' : 'שלח קישור לשיחזור'}
                        </button>
                    </form>
                )}
                
                <div className="text-center mt-6 text-sm text-slate-500">
                    <Link to="/login" className="text-blue-600 font-bold hover:underline">חזרה להתחברות</Link>
                </div>
            </div>
        </div>
    );
}
